import { NeonProviderParams } from './types';

const NeonLayer = window.NeonLayer;
// const isDevelopment =
//   process.env.NODE_ENV === 'development';

export const sendNeonEvent = ({
  action,
  params
}: NeonProviderParams) => {
  NeonLayer.push({ action: action, ...params });
};
